import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberBlurValidation,
  dotNumberValidation,
  withDotValidation,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import SilangPopup from "./SilangPopup";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
import CommonBetHeader from "../../CommonBetHeader";

const Kembang = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "kembangkempis" }));
  }, []);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [totalBetAmount, setTotalBetAmount] = useState([]);
  const [bbPayAmount, setBBPayAmount] = useState(0);

  const initialMoData = [
    {
      gameName: "Kembang",
      position: "Depan",
      numberInput: "",
      sendName: "Kembang-Depan",
    },
    {
      gameName: "Kembang",
      position: "Tengah",
      numberInput: "",
      sendName: "Kembang-Tengah",
    },
    {
      gameName: "Kembang",
      position: "Belakang",
      numberInput: "",
      sendName: "Kembang-Belakang",
    },
    {
      gameName: "Kempis",
      position: "Depan",
      numberInput: "",
      sendName: "Kempis-Depan",
    },
    {
      gameName: "Kempis",
      position: "Tengah",
      numberInput: "",
      sendName: "Kempis-Tengah",
    },
    {
      gameName: "Kempis",
      position: "Belakang",
      numberInput: "",
      sendName: "Kempis-Belakang",
    },
    {
      gameName: "Kembar",
      position: "Depan",
      numberInput: "",
      sendName: "Kembar-Depan",
    },
    {
      gameName: "Kembar",
      position: "Tengah",
      numberInput: "",
      sendName: "Kembar-Tengah",
    },
    {
      gameName: "Kembar",
      position: "Belakang",
      numberInput: "",
      sendName: "Kembar-Belakang",
    },
  ];
  const [moData, setMoData] = useState(initialMoData);

  const [inputs, setInputs] = useState({
    kembangDepan: "",
    kembangTengah: "",
    kembangBelakang: "",
    kempisDepan: "",
    kempisTengah: "",
    kempisBelakang: "",
    kembarDepan: "",
    kembarTengah: "",
    kembarBelakang: "",
  });

  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    handleReset();
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);

  const handleDeafultInputChange = (e) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const mainGroup = ["Kembang", "Kempis", "Kembar"];
  const keiArrayKeys = {
    "Kembang-Depan": "kei_kembang_depan",
    "Kembang-Tengah": "kei_kembang_tengah",
    "Kembang-Belakang": "kei_kembang_belakang",
    "Kempis-Depan": "kei_kempis_depan",
    "Kempis-Tengah": "kei_kempis_tengah",
    "Kempis-Belakang": "kei_kempis_belakang",
    "Kembar-Depan": "kei_kembar_depan",
    "Kembar-Tengah": "kei_kembar_tengah",
    "Kembar-Belakang": "kei_kembar_belakang",
  };

  const handleNumberInputFocus = (index, e, keiKeys) => {
    if (defaultValue !== "" && defaultValue !== undefined) {
      setMoData((prev) => {
        let updateMoData = [...moData];
        updateMoData[index]["numberInput"] = defaultValue;
        return updateMoData;
      });
      calculateAmount(defaultValue, keiKeys, index);
    }
  };

  const validate = () => {
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;
    let msg = "";
    Object.entries(inputs).map((val) => {
      if (val[1]) {
        // if (val[1] < minValue) {
        //   msg = `Minimal bet is ${minValue}`;
        //   return;
        // } else 
        if (val[1] > maxValue) {
          msg = `Your bet nominal exceeds the maximum limit.`;
          return;
        }
      }
    });
    return msg;
  };

  const calculateAmount = (intValue, keiKeys, index) => {
    let keiDiscount = betDiscount[keiKeys];
    let totalAmount = 0;
    let keiValue;
    if (
      intValue != null &&
      intValue != undefined &&
      intValue != "" &&
      !isNaN(intValue)
    ) {
      if (keiDiscount.toString().includes("-")) {
        keiValue =
          intValue * betDiscount.showMultiple -
          (intValue * betDiscount.showMultiple * keiDiscount) / 100;
        totalAmount = keiValue - (keiValue * betDiscount.showDisc) / 100;
      } else {
        keiValue = (intValue * betDiscount.showMultiple) * (betDiscount.showDisc / 100);
        totalAmount = intValue * betDiscount.showMultiple - keiValue;
      }
    }

    setTotalBetAmount((prev) => {
      const updatetotalBet = [...prev];
      updatetotalBet[index] = totalAmount;
      return updatetotalBet;
    });
  };

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const intValue = parseInt(value);
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   setErrorMessage(`Minimal bet is ${minValue}`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (value === "" || (regex.test(value) && !isNaN(intValue))) {
      setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    }
  }, []);

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setMoData(initialMoData);
    setInputs({
      kembangDepan: "",
      kembangTengah: "",
      kembangBelakang: "",
      kempisDepan: "",
      kempisTengah: "",
      kempisBelakang: "",
      kembarDepan: "",
      kembarTengah: "",
      kembarBelakang: "",
    });
    setTotalBetAmount([]);
    setDefaultValue("");
  };

  const submitProcess = async (event) => {
    const msg = await validate();
    if (msg) {
      setErrorMessage(msg);
      setShowErrorPopup(true);
    } else {
      const hasEmptyNumberInput = moData.some(
        (item) => item.numberInput.trim() !== ""
      );

      if (!hasEmptyNumberInput) {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return;
      }
      setShowConfirmationPopup(true);
    }

  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitKembang = (data) => {
    // if (device === "Desktop") {
    //   setShowConfirmationPopup(false);
    //   const dataangka = [];
    //   const {
    //     kembangDepan,
    //     kembangTengah,
    //     kembangBelakang,
    //     kempisDepan,
    //     kempisTengah,
    //     kempisBelakang,
    //     kembarDepan,
    //     kembarTengah,
    //     kembarBelakang,
    //   } = inputs;

    //   const checkAndPush = (condition, label, value) => {
    //     if (condition) {
    //       dataangka.push([label, value * 1000, "success"]);
    //     } else {
    //       dataangka.push(["", "", "null"]);
    //     }
    //   };
    //   checkAndPush(
    //     kembangDepan != 0 && kembangDepan != "",
    //     "Kembang-Depan",
    //     kembangDepan
    //   );
    //   checkAndPush(
    //     kembangTengah != 0 && kembangTengah != "",
    //     "Kembang-Tengah",
    //     kembangTengah
    //   );
    //   checkAndPush(
    //     kembangBelakang != 0 && kembangBelakang != "",
    //     "Kembang-Belakang",
    //     kembangBelakang
    //   );
    //   checkAndPush(
    //     kempisDepan != 0 && kempisDepan != "",
    //     "Kempis-Depan",
    //     kempisDepan
    //   );
    //   checkAndPush(
    //     kempisTengah != 0 && kempisTengah != "",
    //     "Kempis-Tengah",
    //     kempisTengah
    //   );
    //   checkAndPush(
    //     kempisBelakang != 0 && kempisBelakang != "",
    //     "Kempis-Belakang",
    //     kempisBelakang
    //   );
    //   checkAndPush(
    //     kembarDepan != 0 && kembarDepan != "",
    //     "Kembar-Depan",
    //     kembarDepan
    //   );
    //   checkAndPush(
    //     kembarTengah != 0 && kembarTengah != "",
    //     "Kembar-Tengah",
    //     kembarTengah
    //   );
    //   checkAndPush(
    //     kembarBelakang != 0 && kembarBelakang != "",
    //     "Kembar-Belakang",
    //     kembarBelakang
    //   );

    //   data = {
    //     gameId: gameId,
    //     dataangka: dataangka,
    //     gameType: "kembangkempis",
    //     action: "process",
    //     allowPartner: "allowPartner",
    //     betTogelAuth: "betTogelAuth",
    //   };

    //   makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
    //     if (response.status !== respStatus["SUCCESS"]) {
    //       if (response.code === "sub_game_status_close") {
    //         setShowGameClose(true);
    //         showMessage(false);
    //         hideCommonToaster();
    //         dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
    //         return;
    //       }
    //       if (response.code === "market_close_err") {
    //         setShowMarketClose(true);
    //         showMessage(false);
    //         hideCommonToaster();
    //         dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
    //         return;
    //       }
    //       if (response.code !== "validation_error") {
    //         setErrorMessage(props.t(response.code))
    //         setShowErrorPopup(true);
    //         return;
    //       }
    //       showMessage("server error No data found", "error", "error");
    //       return;
    //     }
    //     setSubmitResult(response.data);
    //     dispatch(getUserBalance());
    //   });
    // } else {
    setShowConfirmationPopup(false);

    const dataangka = [];

    moData.forEach((item) => {
      if (item.numberInput.trim() !== "") {
        dataangka.push([item.sendName, item.numberInput * betDiscount.showMultiple, "success"]);
      } else {
        dataangka.push(["", "", "null"]);
      }
    });

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "kembangkempis",
      action: "process",
      allowPartner: "allowPartner",
      betTogelAuth: "betTogelAuth",
    };

    makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data found", "error", "error");
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
    // }
  };

  const handlegameNameChange = (index, event, field) => {
    const newValue = event.target.value;

    setMoData((prevState) => {
      const updatedMoData = [...prevState];

      if (field === "First") {
        updatedMoData[index].gameName = newValue;
      } else if (field === "Second") {
        updatedMoData[index].position = newValue;
      }

      updatedMoData[
        index
      ].sendName = `${updatedMoData[index].gameName}-${updatedMoData[index].position}`;

      return updatedMoData;
    });
  };

  const handleInputBlur = (index, event, keiKeys) => {
    let value = event.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    event.target.value = value;
    handleNumberInputChange(index, event, keiKeys);
  }

  const handleNumberInputChange = (index, event, keiKeys) => {
    let newValue = event.target.value;
    newValue = newValue.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      newValue = dotNumberValidation(newValue);
    } else {
      regex = /^\d*$/;
      newValue = withDotValidation(newValue);
    }
    const intValue = newValue;
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   setErrorMessage(`Minimal bet is ${minValue}`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }


    if (newValue === "" || (regex.test(newValue) && !isNaN(intValue))) {
      setMoData((prevState) => {
        const updatedMoData = [...prevState];
        updatedMoData[index].numberInput = newValue;
        return updatedMoData;
      });
      calculateAmount(intValue, keiKeys, index);
    }
  };

  const resetMo = (index) => {
    setMoData((prevState) => {
      const updatedMoData = [...prevState];
      updatedMoData[index] = {
        gameName: "",
        position: "",
        numberInput: "",
        sendName: "",
      };
      return updatedMoData;
    });
  };

  return (
    <div className="silangkembang_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* {device === "Desktop" ? (
            <>
              <div className="silangkembang_heading">
                <h1>KEMBANG</h1>
              </div>
              <div className="silangkembang_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("bet")}</th>
                      <th>{props.t("Kei")} (%)</th>
                      <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={"even-row"}>
                      <td>1</td>
                      <td>{props.t("front")}</td>
                      <td>
                        {betDiscount.kei_kembang_depan
                          ? `${betDiscount.kei_kembang_depan}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembangDepan"
                          value={inputs.kembangDepan}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"old-row"}>
                      <td>2</td>
                      <td>{props.t("middle")}</td>
                      <td>
                        {betDiscount.kei_kembang_tengah
                          ? `${betDiscount.kei_kembang_tengah}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembangTengah"
                          value={inputs.kembangTengah}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"even-row"}>
                      <td>3</td>
                      <td>{props.t("behind")}</td>
                      <td>
                        {betDiscount.kei_kembang_belakang
                          ? `${betDiscount.kei_kembang_belakang}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembangBelakang"
                          value={inputs.kembangBelakang}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="silangkembang_heading"
                style={{ marginTop: "10px" }}
              >
                <h1>KEMPIS</h1>
              </div>
              <div className="silangkembang_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("bet")}</th>
                      <th>{props.t("Kei")} (%)</th>
                      <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={"even-row"}>
                      <td>1</td>
                      <td>{props.t("front")}</td>
                      <td>
                        {betDiscount.kei_kempis_depan
                          ? `${betDiscount.kei_kempis_depan}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kempisDepan"
                          value={inputs.kempisDepan}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"old-row"}>
                      <td>2</td>
                      <td>{props.t("middle")}</td>
                      <td>
                        {betDiscount.kei_kempis_tengah
                          ? `${betDiscount.kei_kempis_tengah}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kempisTengah"
                          value={inputs.kempisTengah}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"even-row"}>
                      <td>3</td>
                      <td>{props.t("behind")}</td>
                      <td>
                        {betDiscount.kei_kempis_belakang
                          ? `${betDiscount.kei_kempis_belakang}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kempisBelakang"
                          value={inputs.kempisBelakang}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="silangkembang_heading"
                style={{ marginTop: "10px" }}
              >
                <h1>KEMBAR</h1>
              </div>
              <div className="silangkembang_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("bet")}</th>
                      <th>{props.t("Kei")} (%)</th>
                      <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={"even-row"}>
                      <td>1</td>
                      <td>{props.t("front")}</td>
                      <td>
                        {betDiscount.kei_kembar_depan
                          ? `${betDiscount.kei_kembar_depan}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembarDepan"
                          value={inputs.kembarDepan}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"old-row"}>
                      <td>2</td>
                      <td>{props.t("middle")}</td>
                      <td>
                        {betDiscount.kei_kembar_tengah
                          ? `${betDiscount.kei_kembar_tengah}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembarTengah"
                          value={inputs.kembarTengah}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"even-row"}>
                      <td>3</td>
                      <td>{props.t("behind")}</td>
                      <td>
                        {betDiscount.kei_kembar_belakang
                          ? `${betDiscount.kei_kembar_belakang}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="kembarBelakang"
                          value={inputs.kembarBelakang}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ) : ( */}
          <div className="container" style={{ flexDirection: "column" }}>
            {/* {device === "Mobile" && ( */}
            <CommonBetHeader
              rowsToShow={null}
              handleRowsToShowChange={null}
              bbPayAmount={bbPayAmount}
              totalBetAmount={totalBetAmount}
              changeText={"Kembang Kepis"}
            />
            {/* )} */}
            <table className="silang-table tbl_3">
              <thead>
                <tr className="form-input-row odd-row">
                  <th style={{ width: device === "Mobile" ? "80px" : "200px" }}>
                    {props.t("position")}
                  </th>
                  <th style={{ padding: 0, paddingRight: "2px" }}>
                    <table className="data-table" style={{ border: 0 }}>
                      <thead>
                        <tr>
                          <th
                            style={{
                              width: device === "Mobile" ? "80px" : "350px",
                            }}
                          >
                            {props.t("guess")}
                          </th>
                          <th className="offtext">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              <span
                                style={{
                                  width: "53px",
                                  padding: "0 10px",
                                  background: "none",
                                  border: "none",
                                }}
                              >
                                {props.t("Kei")}
                              </span>
                              <input
                                id="inputs"
                                type="text"
                                autoComplete="off"
                                placeholder="Auto Bet"
                                value={defaultValue ? defaultValue : ""}
                                onChange={(e) => handleDeafultInputChange(e)}
                                onBlur={(e) => handleDeafultInputBlur(e)}
                                style={{ padding: "5px 0px" }}
                                inputMode="decimal"
                                pattern="[0-9]*[.,]?[0-9]**"
                              />
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mainGroup.map((item, index) => (
                  <tr
                    key={index}
                    className={`form-input-row ${index % 2 === 0 ? "even-row" : "odd-row"
                      }`}
                  >
                    <td className="form-input-row odd-row">{item}</td>
                    <td style={{ padding: "0" }}>
                      <table border="0" style={{ border: "none" }}>
                        <tbody>
                          {moData.map(
                            (val, ind) =>
                              item === val.gameName && (
                                <tr
                                  key={ind}
                                  className={
                                    Math.floor(ind / 3) % 2 === 0
                                      ? "silang-table tbl_2"
                                      : "bg-color-odd"
                                  }
                                >
                                  <td
                                    style={{
                                      width:
                                        device === "Mobile" ? "80px" : "350px",
                                    }}
                                  >
                                    {val.position}
                                  </td>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "50px",
                                          padding: "0 10px",
                                          background: "none",
                                          border: "none",
                                        }}
                                      >
                                        {" "}
                                        {
                                          betDiscount[
                                          keiArrayKeys[val.sendName]
                                          ]
                                        }
                                      </span>

                                      <input
                                        className="inputs"
                                        // disabled={item.gameName === "" || item.position === ""}
                                        type="text"
                                        placeholder="Bet"
                                        value={
                                          val.numberInput !== ""
                                            ? val.numberInput
                                            : ""
                                        }
                                        inputMode="decimal"
                                        pattern="[0-9]*[.,]?[0-9]**"
                                        onChange={(event) =>
                                          handleNumberInputChange(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                        onFocus={(event) =>
                                          handleNumberInputFocus(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                        onBlur={(event) =>
                                          handleInputBlur(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table></table>
          </div>
          {/* )} */}
          <div className="last_div">
            <div className="left_div">
              <p>{props.t("silang_kembang_kembang_text")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={handleReset}>
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={submitProcess}>
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }

      {submitPopup && (
        <SilangPopup onClose={closeSubmitPopup} submitResult={submitResult} />
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitKembang}
        />
      )}

      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(Kembang);
